import Highcharts from "../../../../shared/highcharts/highchartsSetup";
import CustomHeatmap from "../../../../shared/highcharts/CustomHeatmap";
import React from "react";

const ReportHeatMap = ({dynamicWidth, dynamicHeight, sortedHeatmapData, studentNames, subcategories, isInverted = false, dataClasses, isStandard = false} : any) => {
// console.log(sortedHeatmapData)
    return (
        <CustomHeatmap
            isInverted={isInverted}
            width={dynamicWidth}
            height={dynamicHeight}
            series={[
                {
                    name: '',
                    borderWidth: 2,
                    borderColor: "#FFFFFF",
                    borderRadius: 4,
                    data: sortedHeatmapData,
                    dataLabels: {
                        enabled: true,
                        color: '#00289B',
                        formatter: function (): string {
                            const value = (this as any)?.point?.value; // Use
                            if (isStandard) {
                                return value <= 5 ? "C" :
                                    value <= 7 ? "B" : "A";
                            } else {
                                return value <= 30 ? "E" :
                                    value <= 50 ? "D" :
                                        value <= 70 ? "C" :
                                            value <= 90 ? "B" : "A";
                            }

                        },
                        style: {
                            fontFamily: "'Rubik', 'Helvetica Neue', Arial, sans-serif",
                            fontSize: '13px',
                            fontWeight: '600',
                            textOutline: 'none',
                        },
                    },
                },
            ]}
            xAxis={{
                categories: studentNames,
                lineColor: '#fff',
                lineWidth: 1,
                tickColor: '#ff',
                labels: {
                    style: {
                        fontFamily: "'Rubik', 'Helvetica Neue', Arial, sans-serif",
                        fontSize: '12px',
                        color: '#777777',
                    },
                },
            }}
            yAxis={{
                lineColor: '#fff',
                lineWidth: 1,
                gridLineColor: '#fff',
                gridLineWidth: 1,
                labels: {
                    allowOverlap: true,
                    style: {
                        fontFamily: "'Rubik', 'Helvetica Neue', Arial, sans-serif",
                        fontSize: '12px',
                        color: '#777777',
                        wordBreak: 'break-all',
                        textOverflow: 'allow',
                        width: 350,
                    },
                },
                title: {
                    text: '',
                },
                categories: subcategories,
                reversed: true,
            }}
            colorAxis={{
                min: 0,
                max: 100,
                dataClasses: dataClasses,
            }}
            legend={{
                align: 'left',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                symbolRadius: 4,
                symbolHeight: 12,
                symbolWidth: 12,
                itemStyle: {
                    fontFamily: "'Rubik', 'Helvetica Neue', Arial, sans-serif",
                    fontSize: '12px',
                    fontWeight: '400',
                    color: '#777',
                },
                itemHoverStyle: {
                    color: '#00289B',
                },
            }}
            tooltip={{
                useHTML: true,
                outside: true,
                backgroundColor: 'transparent',
                borderWidth: 0,
                shadow: false,

                formatter: function (this: Highcharts.TooltipFormatterContextObject): string {
                    // 1. Get arrays safely
                    const xCategories = this.series.xAxis?.categories;
                    const yCategories = this.series.yAxis?.categories;

                    // 2. Extract x and y directly from the point object (where heatmaps store them)
                    // Heatmap points contain .x, .y, and .value properties
                    const pointX = this.point.x ?? 0;
                    const pointY = this.point.y ?? 0;
                    const cellValue = this.point.value;

                    // 3. Perform index lookups safely
                    const xCategoryName = xCategories ? xCategories[pointX] : pointX;
                    const yCategoryName = yCategories ? yCategories[pointY] : pointY;
                    return `
                        <div style="
                            background-color: #FFFFFF;
                            color: #00289B;
                            padding: 10px 14px;
                            border-radius: 8px;
                            border: 1px solid #D7E6FF;
                            box-shadow: 0 4px 12px rgba(0, 40, 155, 0.12);
                            font-family: 'Rubik', 'Helvetica Neue', Arial, sans-serif;
                            min-width: 160px;
                            line-height: 1.3;
                        ">
                          <div style="font-size: 0.75rem; font-weight: 400; color: #777777; margin-bottom: 3px; text-transform: uppercase; letter-spacing: 0.5px;">
                            ${yCategoryName}
                          </div>
                          <div style="font-size: 0.9375rem; font-weight: 500; color: #00289B; margin-bottom: 8px;">
                            ${xCategoryName}
                          </div>
                          <div style="display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #EEF2F9; padding-top: 6px;">
                            <span style="font-size: 0.8125rem; color: #777777; font-weight: 400;">${isStandard ? "Notă:" : "Scor:"}</span>
                            <span style="font-size: 0.9375rem; font-weight: 600; color: #0064FF;">${cellValue}</span>
                          </div>
                        </div>
                      `;
                }
            }}
            small={true}
        />
    )
}

export default ReportHeatMap;